<div container [classes]="data.containerSize ? 'container--'+data.containerSize : ''">
  <div class="cta cta--{{data.color}} d-flex flex-column flex-lg-row">
    <div class="cta__img position-relative">
      <picture
        [data]=" {
          image: data.image,
          altext: data.alt || '',
          format: '',
          width: '521',
          height: '328',
          mobile: true,
          webp: true,
          fill:true,
          classes: 'img-fluid object-fit-cover',
        }"
      ></picture>
    </div>
    <div class="cta__text bg-white">
      <h2 class="title text-dark fw-extrabold mb-3" [innerHTML]="data.title"></h2>
      @for (txt of data.text; track $index; let last = $last) {
        <p class="text text-dark" [class.mb-3]="!last" [class.mb-0]="last" [innerHTML]="txt"></p>
      }
      @if (data.cta) {
        <!-- <a class="link btn btn-secondary text-white fw-bold mt-3" [href]="data.cta.url" [innerHTML]="data.cta.title"></a> -->
        <div class="link w-fit mt-3" global-button [buttonData]="{
          buttonLabel: data.cta.title,
          buttonUrl: data.cta.url,
          openInNewTab: data.cta.openInNewTab,
          buttonIcon: 'right-icon'
        }"></div>
      }
    </div>
  </div>
</div>
